import React from 'react';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import ReCAPTCHA from 'react-google-recaptcha';
import { siteKey } from '../../../global/constants';

const Captcha = ({ isoCode, setReCaptchaStatus }) => {
  const onChange = value => {
    let valid = false;
    let showErrorMsg = true;
    if (!isEmpty(value)) {
      valid = true;
      showErrorMsg = false;
    }
    setReCaptchaStatus({ valid, showErrorMsg });
  };
  const captchaProps = {
    hl: isoCode,
    onChange,
  };
  return <ReCAPTCHA {...captchaProps} sitekey={siteKey} data-locator="captcha" />;
};

Captcha.propTypes = {
  isoCode: PropTypes.string,
  setReCaptchaStatus: PropTypes.func,
};
Captcha.defaultProps = {
  isoCode: '',
  setReCaptchaStatus: () => {
    /* default setIsReCaptchaValid handler */
  },
};

export default Captcha;
